export { default } from './DocumentRecipientCopyTag';
